import { render } from "./CSurveyTestsList.vue?vue&type=template&id=167d3958&ts=true"
import script from "./CSurveyTestsList.ts?vue&type=script&lang=ts"
export * from "./CSurveyTestsList.ts?vue&type=script&lang=ts"

import "./CSurveyTestsList.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__